<div class="e-card">
  <div class="e-card-content">
    @if(isTemplate){
      <div appMessageDirective
          [variant]="MessageVariant.Standart"
          [severity]="MessageSeverity.Info"
          cssClass="template-info">
        {{'i18n.domain.import-configuration.edit.template-info' | translate}}
      </div>
    }
    <ejs-tab #tabObj Selecting="Select" id="ic-element" class="mt-2" [animation]="animation" heightAdjustMode="fill" (selecting)="select($event)" (created)="tabGroupCreated()">
      <e-tabitems>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.general' | translate}}
            @if(!formsCoordinationService.configurationFormGeneral.valid && (!formsCoordinationService.configurationFormGeneral.pristine || !formsCoordinationService.isInitialFormValid)){
              <span class="icon-warning--alt text-warning"></span>
            }
          </ng-template>
          <ng-template #content>
            <app-configuration-form-general></app-configuration-form-general>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.time-scedule' | translate}}
            @if(!formsCoordinationService.configurationFormTimeschedule.valid && (!formsCoordinationService.configurationFormTimeschedule.pristine || !formsCoordinationService.isInitialFormValid)){
              <span class="icon-warning--alt text-warning"></span>
            }
          </ng-template>
          <ng-template #content>
            <app-configuration-form-timescedule></app-configuration-form-timescedule>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.email' | translate}}
            @if(!formsCoordinationService.configurationFormEmail.valid && (!formsCoordinationService.configurationFormEmail.pristine || !formsCoordinationService.isInitialFormValid)){
              <span class="icon-warning--alt text-warning"></span>
            }
          </ng-template>
          <ng-template #content>
            <app-configuration-form-email></app-configuration-form-email>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.sftp' | translate}}
          </ng-template>
          <ng-template #content>
            <app-configuration-form-sftp></app-configuration-form-sftp>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.ftp' | translate}}
            @if(!formsCoordinationService.configurationFormFtp.valid && (!formsCoordinationService.configurationFormFtp.pristine || !formsCoordinationService.isInitialFormValid)){
              <span class="icon-warning--alt text-warning"></span>
            }
          </ng-template>
          <ng-template #content>
            <app-configuration-form-ftp></app-configuration-form-ftp>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.rest' | translate}}
            @if(!formsCoordinationService.configurationFormRest.valid && (!formsCoordinationService.configurationFormRest.pristine || !formsCoordinationService.isInitialFormValid)){
              <span class="icon-warning--alt text-warning"></span>
            }
          </ng-template>
          <ng-template #content>
            <app-configuration-form-rest></app-configuration-form-rest>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.as2' | translate}}
            @if(!formsCoordinationService.configurationFormAs2.valid && (!formsCoordinationService.configurationFormAs2.pristine || !formsCoordinationService.isInitialFormValid)){
              <span class="icon-warning--alt text-warning"></span>
            }
          </ng-template>
          <ng-template #content>
            <app-configuration-form-as2></app-configuration-form-as2>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.manual-import' | translate}}
            @if(!formsCoordinationService.configurationFormManualImport.valid && (!formsCoordinationService.configurationFormManualImport.pristine || !formsCoordinationService.isInitialFormValid)){
              <span class="icon-warning--alt text-warning"></span>
            }
          </ng-template>
          <ng-template #content>
            <app-configuration-form-manual-import></app-configuration-form-manual-import>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.file' | translate}}
            @if(!formsCoordinationService.configurationFormFile.valid && (!formsCoordinationService.configurationFormFile.pristine || !formsCoordinationService.isInitialFormValid)){
              <span class="icon-warning--alt text-warning"></span>
            }
          </ng-template>
          <ng-template #content>
            <app-configuration-form-file #configurationFormFileComponent></app-configuration-form-file>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.response' | translate}}
          </ng-template>
          <ng-template #content>
            <app-configuration-form-response></app-configuration-form-response>
          </ng-template>
        </e-tabitem>
        <e-tabitem>
          <ng-template #headerText>
            {{'i18n.domain.import-configuration.edit.tabs.acodis' | translate}}
            @if(!formsCoordinationService.configurationFormAcodis.valid && (!formsCoordinationService.configurationFormAcodis.pristine || !formsCoordinationService.isInitialFormValid)){
              <span class="icon-warning--alt text-warning"></span>
            }
          </ng-template>
          <ng-template #content>
            <app-configuration-form-acodis></app-configuration-form-acodis>
          </ng-template>
        </e-tabitem>
      </e-tabitems>
    </ejs-tab>
  </div>
  <div class="e-card-actions">
    @if(formsCoordinationService.configuration?.id !== 0 && canEdit){
      <button type="button"
              (click)="deleteConfiguration()"
              [disabled]="!canEdit || formsCoordinationService.configuration?.isActive === true"
              class="btn btn-outline-danger mr-2 ">
        <span class="e-icons icon-erase danger me-2"></span>
        {{ (isTemplate ? 'i18n.domain.import-configuration.edit.delete-template' : 'i18n.domain.import-configuration.edit.delete') | translate }}
      </button>
    }
    <div class="right">
      <button type="reset"
              (click)="closeForm()"
              class="btn btn-outline-secondary me-2 btn-fixedw rounded">
        {{ 'i18n.domain.export-configuration.shared.buttons.discard' | translate }}
      </button>
      @if(canEdit){
        <button type="submit"
                (click)="onSave()"
                [disabled]="!canEdit"
                class="btn btn-outline-primary btn-fixedw rounded">
          {{ 'i18n.domain.import-configuration.edit.save' | translate }}
        </button>
      }
    </div>
  </div>
</div>
